export enum SubscriptionsFormFields {
  Subscriptions = 'subscriptions',
}
